import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataAsync, selectApp, setLastFocusedElement, setPage } from "../../app/appSlice";
import Loading from "../../components/Loading/Loading";
import SpatialNavigation from "spatial-navigation-js";
import "./GridPage.css";
import GridVideos from "../../components/GridVideos/GridVideos";
import useSpatialNavigation from "../../useSpatialNavigation";

function GridPage({ category, filterEnabled }) {
  const dispatch = useDispatch();
  const { isLoading, status, page } = useSelector(selectApp);
  const videosRef = useRef(null);

  const uniqueSpatialId = `middlebox-${category}`;
  //useSpatialNavigation(handleScrollY, uniqueSpatialId); // Pass the unique ID to the hook
  useSpatialNavigation(uniqueSpatialId, { enterTo: "last-focused", restrict: 'self-first', straightOnly: false, straightOverlapThreshold: 0.4,leaveFor: { up: "@upperbox" } }, videosRef);

  useEffect(() => {
    
    // Disable unused navigation groups and enable the current one
    SpatialNavigation.disable("middlebox");
    SpatialNavigation.disable("watch-sidebar");
    
    SpatialNavigation.enable(uniqueSpatialId); // Enable the unique group for this category

    return () => {
      SpatialNavigation.remove(uniqueSpatialId); // Cleanup on unmount
    };
  }, [dispatch, uniqueSpatialId]);

  useEffect(() => {
    const fetchDataFromApi = async () => {
      try {
        const result = await dispatch(fetchDataAsync(`/gridpage.php?page=${category}`));
        dispatch(setPage({data: result, name: category}));
      } catch (error) {
        // Handle error
      }
    };

    if(page.name !== category)
      fetchDataFromApi();
  },[dispatch, category, page.name]);

  // Reset scroll to lastfocused on init
  useEffect(() => {
    if(category !== page.name && (!window.location.href.includes("watch")))
      dispatch(setLastFocusedElement(null));
  },[dispatch, category, page.name]);

  // Prevent navigate back from this page & focus upperbox navbar
  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      if(!window.location.href.includes("watch")) {
        // videosRef.current.scrollTo(0,0);
        SpatialNavigation.focus("upperbox");
        window.history.pushState(null, "", window.location.href);
      }      
    };
  
    // Initial fake state to trap user
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);
  
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);
  
  return (
    <div className="main-container grid-style">
      {isLoading && <Loading />}
      {status === "succeeded" && page.name === category && (
        <div
          className="middlebox-wrapper"
          ref={videosRef}
          style={{ overflow: "hidden", position: "relative" }}
        >
        <div>
          <GridVideos
            filterEnabled={filterEnabled}
            //categoryListRef={videosRef}
            categories={page.data}
            spatialElementId={uniqueSpatialId} // Pass the unique ID to the GridVideos component
            slideView={false}
          />
        </div>
        </div>
      )}
      {status === "failed" && <p>Error loading data</p>}
    </div>
  );
}

export default GridPage;
